import Big from "big.js";

export const calculatePrettyBalance = (
    value: number | bigint,
    decimals: number = 18,
    roundOff: boolean = true,
    precision: number = 0
): string => {
    const bigDecimalValue = new Big(value.toString());
    const bigDecimalExpo = new Big(Math.pow(10, decimals).toString());
    const calculated = bigDecimalValue.div(bigDecimalExpo);

    if (decimals === 0 || !roundOff) {
        return calculated.toString();
    }

    const decimalFixed = precision || (calculated.lt(100) ? 6 : 2);
    return calculated.toFixed(decimalFixed);
};
